if (!customElements.get('read-more')) {
  customElements.define(
    'read-more',
    class ReadMore extends HTMLElement {
      constructor() {
        super();

        this.selectors = {
          content: '.read-more__content',
          button: '.read-more__toggle',
          buttonText: '.btn__text',
        };

        this.classes = {
          isDisabled: 'is-disabled',
          isCollapsed: 'is-collapsed',
        };

        this.toggleClass = this.dataset.toggleClass;
        this.showText = this.dataset.showText;
        this.hideText = this.dataset.hideText;

        // Explicitly bind the resize method to maintain 'this' context
        this.checkLineCount = this.checkLineCount.bind(this);
      }

      connectedCallback() {
        this.init();
        this.checkLineCount();
        window.addEventListener('resize', this.checkLineCount);
      }

      disconnectedCallback() {
        // Good practice: Clean up the event listener when component unmounts
        window.removeEventListener('resize', this.checkLineCount);
      }

      init() {
        this.buttonEl = this.querySelector(this.selectors.button);
        this.contentEl = this.querySelector(this.selectors.content);

        if (!this.buttonEl || !this.contentEl) {
          return;
        }

        // 1. Temporarily expand content to calculate natural, full line-count
        this.contentEl.classList.remove(this.toggleClass);
        
        // 2. Run the line count check on uncollapsed height
        this.checkLineCount();
        
        // 3. Setup default collapsed state and add event listener
        this.classList.remove(this.classes.isDisabled);
        this.buttonEl.addEventListener('click', this.onClick.bind(this));
        
        this.contentEl.classList.add(this.toggleClass);
        this.classList.add(this.classes.isCollapsed);
      }

      checkLineCount() {
        if (!this.contentEl || !this.buttonEl) return;

        // 1. Get the computed styles of the content element
        const computedStyle = window.getComputedStyle(this.contentEl);
        
        // 2. Read the -webkit-line-clamp value from your CSS (defaults to 0 if not set)
        const lineClampValue = parseInt(computedStyle.webkitLineClamp, 10) || 0;

        // If no clamp is defined in CSS, we don't need to hide the button
        if (lineClampValue === 0) {
          this.buttonEl.style.removeProperty('display');
          return;
        }

        // 3. Force a temporary unclamp if currently collapsed to calculate real height
        const isCurrentlyCollapsed = this.contentEl.classList.contains(this.toggleClass);
        if (isCurrentlyCollapsed) {
          this.contentEl.classList.remove(this.toggleClass);
        }

        // 4. Calculate total uncollapsed lines
        const lineHeight = parseFloat(computedStyle.lineHeight);
        const totalHeight = this.contentEl.offsetHeight;
        const lines = Math.round(totalHeight / lineHeight);
        
        // 5. Re-apply the collapsed state if it was originally there
        if (isCurrentlyCollapsed) {
          this.contentEl.classList.add(this.toggleClass);
        }

        // 6. Compare actual lines against your CSS line-clamp value
        if (lines > lineClampValue) {
          this.buttonEl.style.removeProperty('display');
        } else {
          this.buttonEl.style.setProperty('display', 'none', 'important');
        }
      }


      showMore() {
        this.contentEl.classList.remove(this.toggleClass);
        this.classList.remove(this.classes.isCollapsed);
        const buttonTextEl = this.buttonEl.querySelector(this.selectors.buttonText);
        if (buttonTextEl) {
          buttonTextEl.textContent = this.hideText;
        }
      }

      showLess() {
        this.contentEl.classList.add(this.toggleClass);
        this.classList.add(this.classes.isCollapsed);
        const buttonTextEl = this.buttonEl.querySelector(this.selectors.buttonText);
        if (buttonTextEl) {
          buttonTextEl.textContent = this.showText;
        }
      }

      onClick(evt) {
        evt.preventDefault();
        if (this.contentEl.classList.contains(this.toggleClass)) {
          this.showMore();
        } else {
          this.showLess();
        }
      }
    }
  );
}
